// Custom Facet Filters - Safe DOM manipulation for filter rendering
(function() {
  'use strict';

  // Ensure FacetFiltersForm is defined
  if (typeof FacetFiltersForm === 'undefined') {
    console.warn('FacetFiltersForm not found. Make sure facets.js is loaded first.');
    return;
  }

  // Override renderFilters with enhanced error handling
  const originalRenderFilters = FacetFiltersForm.renderFilters;

  FacetFiltersForm.renderFilters = function(html, event) {
    try {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

      const facetDetailsElements =
        parsedHTML.querySelectorAll('#FacetSortFiltersForm .js-filter, #FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
      
      const matchesIndex = (element) => { 
        const jsFilter = event ? event.target.closest('.js-filter') : undefined;
        return jsFilter ? element.dataset.index === jsFilter.dataset.index : false; 
      }
      
      const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
      const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

      // UPDATE ONLY SHOP FILTER in custom design
      const customFilterElements = document.querySelectorAll('.custom-collection-filter .js-filter');
      customFilterElements.forEach((customElement) => {
        // Only sync if this is a Shop filter
        if (!customElement.classList.contains('facet-Shop')) return;
        
        const dataIndex = customElement.getAttribute('data-index');
        if (!dataIndex) return; // Skip if no data-index
        
        // Match Shop filter from parsed HTML
        let parsedElement = parsedHTML.querySelector(`.js-filter.facet-Shop[data-index="${dataIndex}"]`);
        
        // If not found, try to find any Shop filter
        if (!parsedElement) {
          parsedElement = parsedHTML.querySelector(`.js-filter.facet-Shop`);
        }
        
        if (parsedElement && parsedElement.innerHTML) {
          customElement.innerHTML = parsedElement.innerHTML;
        }
      });
      
      // Remove any non-Shop filters that might have been added
      const allCustomFilters = document.querySelectorAll('.custom-collection-filter .js-filter');
      allCustomFilters.forEach((filter) => {
        if (!filter.classList.contains('facet-Shop')) {
          filter.remove();
        }
      });

      // SAFE: Add null check before setting innerHTML for standard filters
      facetsToRender.forEach((element) => {
        const targetElements = document.querySelectorAll(`.js-filter[data-index="${element.dataset.index}"]:not(.custom-collection-filter .js-filter)`);
        targetElements.forEach((targetElement) => {
          if (element.innerHTML) {
            targetElement.innerHTML = element.innerHTML;
          }
        });
      });

      FacetFiltersForm.renderActiveFacets(parsedHTML);
      FacetFiltersForm.renderAdditionalElements(parsedHTML);

      if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

      const facetDrawer = document.getElementById('FacetDrawer');
      if (facetDrawer) {
        facetDrawer.classList.remove('loading');
      }
    } catch (error) {
      console.error('Error in custom facet filter rendering:', error);
      // Fallback to original method if available
      if (originalRenderFilters) {
        originalRenderFilters.call(this, html, event);
      }
    }
  }

})();
